module.exports = __webpack_public_path__ + "img/42.87282fba.jpg";